<template>
  <div>
    <div class="text-center primary--text">
      <span class="font-weight-black text-uppercase">{{creditInformation.Product.name}}</span> <br>
      <span class="font-weight-bold">
        Línea autorizada de {{creditInformation.creditLimit | currency({fractionCount: 0 }) }} {{creditInformation.creditCurrency}}
      </span>
    </div>
    <b-progress :max="max" show-value height="1.7vw">
      <b-progress-bar :id="usedCreditId"
                      :value="progressData.used['percent']"
                      variant="info"
                      :label-html="`${progressData.used['percent'].toFixed(1)}%`"/>
      <b-progress-bar :id="toSellCredit"
                      :value="progressData.toSell['percent']"
                      :variant="toSellClass"
                      :label-html="`${progressData.toSell['percent'].toFixed(1)}%`"/>
      <b-progress-bar :id="availableCredit"
                      :value="progressData.available['percent']"
                      :variant="availableClass"
                      :label-html="`${progressData.available['percent'].toFixed(1)}%`"/>
    </b-progress>
    <div class="text-center primary--text font-weight-bold" style="margin-top: 5px;">
      De los cuales {{ progressData.toSell['value'] | currency({fractionCount: 2 }) }} {{creditInformation.creditCurrency}} están sujetos a validación.
      <!-- <div class="font-weight-medium" style="font-size: 11px;" v-show="creditInformation.multimoneda === true">Considerando un tipo de cambio de {{ creditInformation.tipoCambio | currency({fractionCount: 4 }) }}.</div> -->
      <span v-if="showOverDraft" style="color: #F34F50"><br>
        <v-icon dense dark color="#F34F50">mdi-alert-rhombus</v-icon>
        Solo cuentas con {{ progressData.available['value'] | currency({fractionCount: 2 }) }} {{creditInformation.creditCurrency}} para venta
      </span>
    </div>
    <b-tooltip custom-class="my-tooltip-class" :target="usedCreditId">
      <div class="tooltip-title">Saldo Actual</div>
      <div class="tooltip-content">{{ creditInformation.creditUsed | currency({fractionCount: 0}) }} {{creditInformation.creditCurrency}}</div>
    </b-tooltip>
    <b-tooltip custom-class="my-tooltip-class" :target="toSellCredit">
      <div class="tooltip-title">Por vender</div>
      <div class="tooltip-content"> {{ progressData.toSell['value'] | currency({fractionCount: 0 }) }} {{creditInformation.creditCurrency}}</div>
    </b-tooltip>
    <b-tooltip custom-class="my-tooltip-class" :target="availableCredit">
      <div class="tooltip-title">Crédito Disponible</div>
      <div class="tooltip-content"> {{ progressData.available['value'] | currency({fractionCount: 0 }) }} {{creditInformation.creditCurrency}}</div>
    </b-tooltip>
  </div>
</template>

<script>
import { BProgress, BProgressBar, BTooltip } from 'bootstrap-vue'

export default {
  props: {
    creditInformation: Object,
    progressData: Object,
    showOverDraft: Boolean
  },
  components: {
    BProgress,
    BProgressBar,
    BTooltip
  },
  data () {
    return {
      toSellClass: 'dark',
      availableClass: 'success',
      max: 100,
      usedCreditId: '',
      toSellCredit: '',
      availableCredit: '',
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted () {
    this.usedCreditId = this._uid.toString() + '-used'
    this.toSellCredit = this._uid.toString() + '-toSell'
    this.availableCredit = this._uid.toString() + '-available'
  },
  watch: {
    progressData: function (oldVal, newVal) {
      this.setClases()
    }
  },
  methods: {
    setClases () {
      if (this.progressData.available.percent <= 0) {
        this.progressData.availableClass = 'danger'
        this.toSellClass = 'danger'
      } else if (this.progressData.available.percent <= 15) {
        this.availableClass = 'danger'
        this.toSellClass = 'dark'
      } else {
        this.toSellClass = 'dark'
        this.availableClass = 'success'
      }
    }
  }
}
</script>

<style scoped src="../../../node_modules/bootstrap/dist/css/bootstrap.css"></style>
<style scoped src="../../../node_modules/bootstrap-vue/dist/bootstrap-vue.css"></style>

<style scoped>
  .v-progress-linear {
    width: 65%;
  }
  .progress {
    border-radius: 25px;
    box-shadow:
      0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 6px 10px 0px rgba(0, 0, 0, 0.14),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .progress-bar {
    color: white;
    font-weight: 700;
    font-size: 0.9vw;
  }
  .bg-info {
    background-color: #5C9DF2 !important;
  }
  .bg-success {
    background-color: #a9a9aa !important;
  }
  .bg-dark {
    background-color: #1374F2 !important;
  }
  .bg-danger {
    background-color: #FF6E65 !important;
  }
  .my-tooltip-class {
    color: white!important;
    background-color: black !important;
    width: 13% !important;
    border-radius: 8px;
    text-align: center;
  }
  .tooltip-title {
    font-weight: bolder;
  }
</style>
